import React from 'react';

import { FormConsumer } from '../Form';

function ErrorMessage(props) {
  return (
    <FormConsumer>
      {({ errors }) => (
        errors.generic && <div id="mtm-error" className="callout alert">{errors.generic}</div>
      )}
    </FormConsumer>
  );
}

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/ErrorMessage/index.js